import * as Icons from "lucide-react";
import { type LucideProps } from "lucide-react";

type IconName = keyof typeof Icons;

interface IconProps extends LucideProps {
  name: string;
  fallback?: string;
}

/**
 * Dynamic Lucide icon resolver. Pass a lucide icon name (PascalCase) as string.
 */
export function Icon({ name, fallback = "Sparkles", ...props }: IconProps) {
  const lib = Icons as unknown as Record<string, Icons.LucideIcon>;
  const Cmp = (lib[name] ?? lib[fallback] ?? Icons.Sparkles) as Icons.LucideIcon;
  return <Cmp {...props} />;
}

export type { IconName };
